import { render, staticRenderFns } from "./CircolariAutomatiche.vue?vue&type=template&id=4b138dee&scoped=true&"
import script from "./CircolariAutomatiche.vue?vue&type=script&lang=js&"
export * from "./CircolariAutomatiche.vue?vue&type=script&lang=js&"
import style0 from "./CircolariAutomatiche.vue?vue&type=style&index=0&id=4b138dee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b138dee",
  null
  
)

export default component.exports